import { Typography } from "@mui/material";

const PageHeader = (props) => {
    return (
        <div id="header">
            <Typography variant="h6" sx={{ background:'#bcb7b7', color:'white', p: 0.5}}>{props.title}</Typography>
        </div>
    )
}

export default PageHeader;